import { cn } from "@gymflow/helpers";

import { CheckIcon } from "../../../atoms";
import { StepWizardArrowIcon } from "../../../atoms/icons/StepWizardArrowIcon";

type StepTabItemProps = {
  title: string;
  index: number;
  stepsLength: number;
  activeStepIndex: number;
  stepRef?: (el: HTMLDivElement | null) => void;
};

export const StepTabItem = ({
  title,
  index,
  stepsLength,
  activeStepIndex,
  stepRef,
}: StepTabItemProps) => {
  const isLast = index === stepsLength - 1;
  const number = index + 1;
  const isActive = activeStepIndex >= index;
  const isDone = activeStepIndex > index;

  return (
    <div className="flex min-w-max flex-1 flex-row" ref={stepRef}>
      <div className="flex flex-1 flex-row items-center gap-3 p-3 lg:px-6 lg:py-4">
        <div
          className={cn(
            "flex size-[1.875rem] items-center justify-center rounded-full border-2 border-gray-500 lg:size-9",
            { "border-secondary-500": isActive, "bg-secondary-500": isDone },
          )}
        >
          {isDone ? (
            <CheckIcon className="size-4" pathClassName="stroke-gray-0" />
          ) : (
            <div
              className={cn("text-base font-semibold text-gray-500", {
                "text-secondary-500": isActive,
              })}
            >
              {number}
            </div>
          )}
        </div>
        <div
          className={cn("text-base font-medium text-gray-500", {
            "text-secondary-500": isActive,
          })}
        >
          {title}
        </div>
      </div>
      <div className="flex items-stretch">
        <StepWizardArrowIcon
          className={cn("h-full w-auto", {
            hidden: isLast,
          })}
        />
      </div>
    </div>
  );
};
